module.exports = __webpack_public_path__ + "img/btn_menu-open.ecee8f71.png";